<template>
  <div class="comfortable-credit-info">
    <h2 class="title fn-title-1">Кредит “Зручний”</h2>

    <p class="m-body-m description">
      Кредит без застави на будь-які бізнес-цілі. Надається у вигляді безготівкових коштів відразу всією сумою на
      поточний рахунок з терміном погашення до 36 міс. та переплатою в місяць від 1,65%
    </p>

    <ul class="tabs">
      <li class="item m-body-sb" :class="{ active: typeLocal === 'flp' }" v-on:click="checkType('flp')">Підприємець</li>
      <li class="item m-body-sb" :class="{ active: typeLocal === 'jur' }" v-on:click="checkType('jur')">Юридична особа</li>
    </ul>

    <div v-if="typeLocal === 'flp'" class="tab-content tab-content-flp">
      <h4 class="content-title m-body-sb">Умови:</h4>

      <div class="row">
        <div class="column row-title m-body-m">сума кредиту:</div>
        <div class="column row-value m-body-b">50 000 - 500 000 грн</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">термін кредиту:</div>
        <div class="column row-value m-body-b">
          <div class="third">12 міс.</div>
          <div class="third">24 міс.</div>
          <div class="third">36 міс.</div>
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">середня переплата <br>в місяць:</div>
        <div class="column row-value m-body-b">
          <div class="third">від 1,46%</div>
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">комісія за видачу:</div>
        <div class="column row-value m-body-b">0%</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">комісія за дострокове погашення:</div>
        <div class="column row-value m-body-b">1% (у перші 4 міс., потім 0%)</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">графік погашення:</div>
        <div class="column row-value m-body-b">рівними частинами (ануїтет)</div>
      </div>

      <h4 class="content-title m-body-sb">Документи для заявки:</h4>

      <div class="row">
        <div class="column row-title m-body-m w100">
          декларація про доходи за останній звітній період (не меньш ніж за півроку)
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          виписка за рахунками ФОП свого банку з детальним розшифруванням рухів коштів за останні 12 міс.
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фото бізнесу (місце розташування торгової точки, асортимент товару, офіс і т.д.)
        </div>
      </div>
    </div>

    <div v-if="typeLocal === 'jur'" class="tab-content tab-content-jur">
      <h4 class="content-title m-body-sb">Умови:</h4>
      <div class="row">
        <div class="column row-title m-body-m">сума кредиту:</div>
        <div class="column row-value m-body-b">50 000 - 1 000 000 грн</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">термін кредиту:</div>
        <div class="column row-value m-body-b">
          <div class="third">12 міс.</div>
          <div class="third">24 міс.</div>
          <div class="third">36 міс.</div>
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">середня переплата<br> в місяць:</div>
        <div class="column row-value m-body-b">
          <div class="third">від 1,46%</div>
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">комісія за видачу:</div>
        <div class="column row-value m-body-b">0%</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">комісія за дострокове погашення:</div>
        <div class="column row-value m-body-b">1% (у перші 4 міс., потім 0%)</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">графік погашення:</div>
        <div class="column row-value m-body-b">рівними частинами (ануїтет)</div>
      </div>

      <h4 class="content-title m-body-sb">Документи для заявки:</h4>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фінансова звітність за останній звітний рік
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          виписка за рахунками свого банку з детальним розшифруванням рухів коштів за останні 12 міс.
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фото бізнесу (місце розташування торгової точки, асортимент товару, офіс і т.д.)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'flp'
    }
  },
  data: function () {
    return {
      typeLocal: ''
    }
  },
  methods: {
    checkType: function (type) {
      this.typeLocal = type
      this.$emit('update:type', type)
    }
  },
  watch: {
    type: {
      immediate: true,
      handler (val) {
        this.typeLocal = val
      }
    }
  }
}
</script>

<style scoped lang="less">
.comfortable-credit-info {
  text-align: left;

  .title {
    margin: 0 0 16px 0;
    color: var(--black);
  }

  .description {
    margin: 0 0 36px 0;
    color: var(--black);
  }

  .tab-content {
    margin: 42px 0 0 0;

    .content-title {
      margin: 0 0 8px 0;
      color: var(--grey-140)
    }

    .row {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-top: 1px solid var(--grey-240);

      .column {
        width: 50%;
      }

      .row-title {
        position: relative;
        padding: 0 0 0 24px;
        color: var(--black);

        &:before {
          content: '';
          position: absolute;
          top: 7px;
          left: 8px;
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background: var(--second-base);
        }
      }

      .row-value {
        display: flex;
        color: var(--black);

        .third {
          width: 33%;
        }
      }
    }

    .row + .content-title {
      margin: 52px 0 8px 0;
    }
  }
}
</style>
